<template>
  <div>
    <div
      class="w-full mt-4 px-2 cursor-pointer rounded"
      :id="`submission-card-${submission.id}`"
      :class="[
        !submissionOpened ? ['clickable', 'collapsed-card'] : null,
        submission.is_hidden ? 'hidden-record' : '',
      ]"
      @mouseover="isHoverCard = true"
      @mouseleave="isHoverCard = false"
      @click="handleClickSubmission()"
    >
      <CardHeader
        :showCollapseButton="submissionOpened"
        :submission="submission"
        :isInSummary="isInSummary"
        :isInPlag="isPlagPanel"
        :plagPanelName="plagStudentName"
        :loadingSubmission="loadingSubmission"
        :showVerticalDotMenu="showVerticalDotMenu"
        :isCardHover="isHoverCard"
        @minimize="closeSubmission"
        @showHistoryVersion="showHistoryVersion"
        @showDeleteSubmissionModal="
          $emit('showDeleteSubmissionModal', submission)
        "
        @showHideSubmissionModal="$emit('showHideSubmissionModal', submission)"
        @addModelSubmission="addModelSubmission"
        @showAnonymousDescription="openAnonymityModal"
        @closeSubmission="collapseSubmissionCard"
        @openSubmission="EventBus.$emit('sidebar-recap', false); handleTabButtons('comments', 'card')"
      />
      <div
        class="ml-11"
        @click.stop.prevent="
          !submissionOpened ? handleTabButtons('comments', 'card') : ''
        "
      >
        <div class="submission-response mb-3" v-if="submissionOpened">
          <section
            class="text-sm text-justify"
            v-html="getSubmissionPromptResponse"
          />
          <p class="mt-4 text-left text-xs text-gray-600">
            {{ getPromptWordsLength }} Words
          </p>
        </div>
        <div v-else>
          <section class="ellipsis-text text-left text-sm">
            {{ getTrimmedSubmissionPromptResponse }}
          </section>
        </div>
        <div :id="`submission-tab-row-${submission.id}`" class="flex py-5">
          <button
            @click.stop.prevent="handleTabButtons('comments', true)"
            class="mr-2 px-5 py-2 bg-gray-100 cursor-pointer border border-solid border-gray-200 rounded text-xs font-semibold hover:border-blueGray-500 hover:text-white hover:bg-blueGray-500"
            :class="[
              cardTabButtonClasses('comments'),
              collapse_comments === false
                ? 'bg-blueGray-500 text-white'
                : 'text-gray-400',
            ]"
          >
            Comments ({{ submission.comment_count }})
          </button>
          <button
            v-if="
              (hasTeacherPermissionsInCourse &&
                !submission.teacher_submission) ||
              (!hasTeacherPermissionsInCourse &&
                submission.id === getMyRTUserDetails.submission_id)
            "
            @click.stop.prevent="handleTabButtons('assessment', 'card')"
            class="flex items-center rounded px-5 py-2 cursor-pointer text-xs font-semibold hover:bg-blueGray-500 hover:text-white hover:border-blueGray-500 border border-solid border-gray-200"
            :class="[
              cardTabButtonClasses('assessment'),
              hasEvaluation(submission) && collapse_assessment === true
                ? 'text-green-500 hover:text-white'
                : collapse_assessment === false
                ? 'text-white'
                : 'text-gray-400',
              collapse_assessment === false
                ? 'bg-blueGray-500 text-white border-blueGray-500'
                : ' bg-gray-100',
            ]"
          >
            Assessment
            <i v-if="hasEvaluation(submission)" class="fas fa-check ml-2"></i>
          </button>
        </div>
        <CommentsTab
          v-if="
            (tabToShow === 'comments' && submissionOpened) ||
            model_submission_show
          "
          :key="`comment-${submission.id}`"
          :submission="submission"
          :showComments="show_comments"
          :showModelSubmission="model_submission_show"
          :isInSummary="isInSummary"
          @toggleSubmissionComments="toggleSubmissionComments"
          @getComments="getComments"
          @closeModelSubmission="closeModelSubmission"
          :isFromNotification="isFromNotification"
        />
        <div v-if="submissionOpened" class="my-6 flex justify-center">
          <button
            key="collapse"
            @click.stop.prevent="collapseSubmissionCard()"
            class="bg-white text-blueGray-500 hover:border-blueGray-700 hover:text-blueGray-700 border border-solid border-blueGray-500 rounded-full px-4 py-1"
          >
            <i class="fa-solid fa-angle-up"></i>
          </button>
        </div>
      </div>
    </div>
    <!-- Modals -->
    <AnonymousCharacterDescriptionModal
      v-if="show_anonymous_description_modal"
      :anonymous_identity="identity_to_show"
      @close="show_anonymous_description_modal = false"
    />
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import store from 'store';
  import get from 'lodash/get';
  import { encodeImageUrl } from 'utils/encodeImage';
  import wordCountService from '../../services/wordCount/wordCount';

  export default Vue.extend({
    components: {
      CardHeader: () => import('./cardHeader'),
      CommentsTab: () => import('../commentsTab.vue'),
      AnonymousCharacterDescriptionModal: () =>
        'components/modals/anonymousCharacterDescriptionModal',
    },
    watch: {
      $route: function () {
        const { submissionId, tab, activityID } = this.$route.query;
        if (submissionId && tab) {
          if (this.submission.id === submissionId) this.changeTab('comments');
        }
        if (activityID) this.scrollToSummarySubmission();
      },
      'submission.comments': function () {
        let count = 0;
        if (this.submission.comments && this.submission.comments.length) {
          this.submission.comments.forEach((c) => {
            if (!c.is_model_submission && this.hasTeacherPermissionsInCourse)
              count++;
            else if (!c.is_model_submission) {
              if (!c.is_hidden) count++;
              else if (
                c.is_hidden &&
                this.owncomment(c.user_id, c.anonymous_identity_id)
              )
                count++;
            }
          });
        }
        this.comment_count = count;
      },
      // Verificar se está a aser utiliozada
      isAnonForPlagPanel: function () {
        if (this.isPlagPanel) {
          this.getCurrentRT.submissions.forEach((sub) => {
            if (sub.id === this.submission.id) {
              if (this.isAnonForPlagPanel) {
                this.imageUrl = encodeImageUrl(
                  sub.anonymous_identity.avatar_url
                );
                this.plagStudentName = sub.anonymous_identity.name;
              } else {
                this.imageUrl = encodeImageUrl(sub.user.avatar_url);
                this.plagStudentName = sub.user.name;
              }
            }
          });
        }
      },
    },
    props: {
      submission: {
        type: Object,
        default: {},
      },
      isInSummary: {
        type: Boolean,
        default: false,
      },
      // Verificar se está a ser utilizado
      hasNext: {
        type: Boolean,
        default: false,
      },
      // Verificar se está a ser utilizado
      index: {
        type: Number,
        default: 0,
      },
      studentActivitySummary: {
        type: Boolean,
        default: false,
      },
      isPlagPanel: {
        type: Boolean,
        default: false,
      },
      isAnonForPlagPanel: {
        type: Boolean,
        default: false,
      },
      showVerticalDotMenu: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        show_anonymous_description_modal: false,
        identity_to_show: {},
        tab_on_summary: 'comments', // TEMP bug fix sorry
        comment: {
          submission_id: null,
          content: '',
        },
        show_comments: true,
        show_submission: false,
        show_turalt_results: false,
        model_submission_show: false,
        comment_count: 0,
        submission_history_version: null,
        submission_history_word_count: null,
        trimmed_submission_history_version: null,
        showSubmissionSummary: false,
        imageUrl: '',
        plagStudentName: '',
        loadingSubmission: undefined,
        collapse_comments: true,
        collapse_assessment: true,
        isFromNotification: false,
        studentIdFromStudentReports: '',
        isHoverCard: false,
      };
    },
    computed: {
      ...mapGetters([
        'getCurrentRT',
        'hasTeacherPermissionsInCourse',
        'getMyRTUserDetails',
        'getStudentSummary',
        'getProfile',
        'summaryOverlayOpened',
        'getOrderedSubmissions',
        'getMySubmission',
      ]),
      getPromptWordsLength() {
        const submission_history = {
          prompt_response: this.submission_history_version,
          word_count: this.submission_history_word_count,
        };
        const submission = this.submission_history_version
          ? submission_history
          : this.submission;
        return (
          this.submission_history_word_count ||
          wordCountService.getWordCount(submission)
        );
      },
      getSubmissionPromptResponse() {
        return (
          this.submission_history_version ||
          this.submission.prompt_response ||
          ''
        );
      },
      getTrimmedSubmissionPromptResponse() {
        const trimmed_submission_prompt_response =
          this.trimmed_submission_history_version ||
          this.submission.trimmed_prompt_response ||
          '';
        return trimmed_submission_prompt_response;
      },
      tabToShow() {
        // Always show 'comments' if summary does not match submission
        const intendedTab = this.submission.tab || 'comments';
        if (this.getStudentSummary) {
          const isCorrectSubmissionInSummary =
            this.getStudentSummary.submission_id !== this.submission.id;
          return isCorrectSubmissionInSummary ? 'comments' : intendedTab;
        }
      },
      submissionOpened() {
        return this.studentActivitySummary
          ? this.showSubmissionSummary
          : this.submission.opened_submission;
      },
      canShowAnonymousIdentity() {
        if (
          this.getCurrentRT.enable_annonymous &&
          !this.getCurrentRT.reveal_names
        ) {
          return true;
        } else if (
          this.getCurrentRT.enable_annonymous &&
          this.getCurrentRT.reveal_names
        ) {
          return false;
        }
        return true;
      },
      anonymous_identity_tooltip_content() {
        const { enable_annonymous, reveal_names } = this.getCurrentRT;
        const description = get(
          this,
          'submission.anonymous_identity.description'
        );
        const show_anonymous_description =
          enable_annonymous && !reveal_names && description;
        if (show_anonymous_description && !this.submission.teacher_submission) {
          // 25 innitial words of text
          const truncated_string = description
            .split(' ')
            .splice(0, 25)
            .join(' ');
          return (
            truncated_string +
            '...<br/><strong>(click image to learn more)</strong>'
          );
        } else {
          return '';
        }
      },
      isFromNotificationState() {
        return this.$store.state.isFromNotification;
      },
      rt_discussion() {
        return this.$route.name === 'roundtable.discussion';
      },
    },
    methods: {
      handleClickSubmission: async function() {
        return EventBus.$emit('sidebar-recap', false);
      },
      isMountedFromNotification: function () {
        if (
          this.submission.id === this.$route.query.submissionID &&
          this.isFromNotificationState === true
        ) {
          const submissionElement = document.getElementById(
            `submission-card-${this.submission.id}`
          );
          if (this.$router.currentRoute.query.assessment === true) {
            return this.$store
              .dispatch('submissionClicked', this.submission.id)
              .then(() => {
                this.loadingSubmission = false;
                setTimeout(() => {
                  this.$emit('openAssessmentTab', this.submission.id);
                }, 100);
              });
          } else {
            this.$store
              .dispatch('submissionClicked', this.$route.query.submissionID)
              .then(() => {
                this.changeTab('comments').then(() => {
                  this.show_comments = true;
                  submissionElement.scrollIntoView({
                    block: 'start',
                    behavior: 'smooth',
                    inline: 'start',
                  });
                  this.isFromNotification = true;
                });
              });
          }
        }
      },
      addModelSubmission: function (submission_id) {
        if (this.model_submission_show === true) {
          this.collapseSubmissionCard();
        } else {
          if (this.submission.id === submission_id) {
            this.handleTabButtons('comments', true);
            this.model_submission_show = true;
            if (this.submission.comments) {
              const isModelSubmission = this.submission.comments.find(
                (c) => c.is_model_submission && c.user_id === this.getProfile.id
              );
              if (isModelSubmission) {
                EventBus.$emit(
                  'edit-model-submission',
                  isModelSubmission,
                  false
                );
              } else {
                EventBus.$emit('edit-model-submission', null, true);
              }
            } else {
              EventBus.$emit('edit-model-submission', null, true);
            }
          }
        }
      },
      collapseSubmissionCard: function () {
        if (this.$route.query) {
          this.$router.replace({ query: null });
        }
        this.collapse_comments = true;
        this.collapse_assessment = true;
        this.model_submission_show = false;
        this.$store.commit('UPDATE_SUBMISSION_SPREAD', {
          id: this.submission.id,
          opened_submission: false,
        });
        if (this.studentActivitySummary) this.showSubmissionSummary = false;
        this.scrollToSubmission(true);
      },
      openSubmission: function () {
        if (!this.submission.opened_submission) {
          this.show_comments = true;
          if (this.studentActivitySummary) this.showSubmissionSummary = true;
          this.getComments();
        }
      },
      closeSubmission: function () {
        this.model_submission_show = false;
        this.$store.commit('UPDATE_SUBMISSION_SPREAD', {
          id: this.submission.id,
          opened_submission: false,
        });
        if (this.studentActivitySummary) this.showSubmissionSummary = false;
      },
      openAnonymityModal: function () {
        const { enable_annonymous, reveal_names } = this.getCurrentRT;
        const { description } = this.submission.anonymous_identity;
        const show_anonymous_description = enable_annonymous && !reveal_names && description;
        if (this.getCurrentRT.enable_annonymous && this.canShowAnonymousIdentity) {
          if (this.summaryOverlayOpened) {
            if (show_anonymous_description && !this.submission.teacher_submission) {
              this.show_anonymous_description_modal = true;
              this.identity_to_show = this.submission.anonymous_identity;
            }
          } else {
            this.$emit('openAnonymityModal', this.submission.anonymous_identity);
          }
        }
      },
      cardTabButtonClasses(tab) {
        return {
          'expanded-card-tab':
            this.submission.opened_submission || this.showSubmissionSummary,
          'active-tab':
            tab === this.tabToShow &&
            (this.submission.opened_submission || this.showSubmissionSummary),
          'inactive-tab': tab !== this.tabToShow,
        };
      },
      async handleTabButtons(tab, option) {
        EventBus.$emit('sidebar-recap', false);
        if (this.$route.query) {
          this.$router.replace({ query: null });
        }
        if (!this.collapse_comments && tab === 'comments') {
          EventBus.$emit('sidebar-recap', false);
          this.collapse_comments = true;
          this.collapseSubmissionCard();
        } else if (!this.collapse_assessment && tab === 'assessment') {
          EventBus.$emit('sidebar-recap', false);
          this.collapse_assessment = true;
          this.collapseSubmissionCard();
        } else {
          if (this.submission.is_genie_assessment_run) return;
          this.tab_on_summary = tab;
          const action = this.studentActivitySummary
            ? 'loadSubmission'
            : 'submissionClicked';
          const scroll_to_comments = option !== 'card' ? false : true;
          this.loadingSubmission = true;
          this.collapse_assessment = true;
          this.collapse_comments = false;
          this.show_comments = true;
          this.$store.commit('setIsFromNotification', false);
          if (!this.submission.comments) {
            this.$store.dispatch(action, this.submission.id).then(() => {
              this.loadingSubmission = false;
              this.scrollToSubmission(scroll_to_comments);
            });
          } else {
            this.openSubmission();
            this.$store
              .dispatch('loadSubmissionComments', this.submission.id)
              .then(() => {
                this.loadingSubmission = false;
                this.scrollToSubmission(scroll_to_comments);
              });
          }
          if (
            (this.hasTeacherPermissionsInCourse ||
              this.submission.id === this.getMyRTUserDetails.submission_id) &&
            this.getStudentSummary.submission_id !== this.submission.id
          ) {
            await this.$store.dispatch(
              'getSubmissionSummary',
              this.submission.id
            );
          }
          if (
            !this.submission.teacher_submission &&
            (this.hasTeacherPermissionsInCourse ||
              this.submission.id === this.getMyRTUserDetails.submission_id)
          ) {
            this.$emit('openAssessmentTab');
          }
        }
      },
      changeTab(tab) {
        this.tab_on_summary = tab;
        return this.$store.dispatch('updateSubmissionSpread', {
          id: this.submission.id,
          opened_submission: true,
          tab,
        });
      },
      isMountedFromStudentReports: async function () {
        if (this.$route.name === 'course.student-reports.discussion') {
          const { studentID } = this.$route.params;
          this.handleTabButtons('assessment', true);
          await store.dispatch('submissionClicked', this.submission.id);
          this.studentIdFromStudentReports = studentID;
        }
      },
      toggleSubmissionComments() {
        this.submission.comments
          ? this.toggleShowComments()
          : this.getComments();
      },
      toggleShowComments() {
        this.show_comments = !this.show_comments;
        this.model_submission_show = false;
      },
      getComments() {
        this.loadingSubmission = true;
        this.show_comments = true;
        if (this.submission.comments) {
          this.$store.commit('UPDATE_SUBMISSION_SPREAD', {
            id: this.submission.id,
            opened_submission: true,
          });
          this.loadingSubmission = false;
          return Promise.resolve(); // report page comes with comments already, should not fetch again,
        }
        return this.$store
          .dispatch('submissionClicked', this.submission.id)
          .then(() => (this.loadingSubmission = false));
      },
      scrollToSubmission(options) {
        const goToTab = options;
        let submissionToScrollToElement = goToTab
          ? document.getElementById(`feed-${this.submission.id}`)
          : document.getElementById(`submission-tab-row-${this.submission.id}`);
        if (submissionToScrollToElement) {
          setTimeout(() => {
            // const nodeList = document.querySelectorAll(
            //   `#feed-${this.submission.id}`
            // );
            // if (nodeList.length === 1) {
            //   [submissionToScrollToElement] = nodeList;
            // } else {
            //   submissionToScrollToElement = Array.from(nodeList).find(
            //     (node) =>
            //       node.parentElement
            //         .closest('.vue-recycle-scroller__item-view')
            //         .style.transform.split('translateY(')[1]
            //         .split('px)')[0] >= 0
            //   );
            // }
            if (submissionToScrollToElement) {
              submissionToScrollToElement.scrollIntoView({
                block: 'start',
                inline: 'nearest',
                behavior: 'smooth',
              });
            }
          }, 0);
        }
      },
      owncomment(userID, anonymousIdentityId) {
        return (
          this.getProfile.my_rt_user_details.id === userID ||
          this.getProfile.my_rt_user_details.id === anonymousIdentityId
        );
      },
      showHistoryVersion(version, submission_id) {
        if (this.submission.id === submission_id) {
          this.submission_history_version = version.prompt_response;
          this.trimmed_submission_history_version =
            version.trimmed_prompt_response;
          this.submission_history_word_count = version.word_count;
        }
      },
      closeModelSubmission() {
        this.model_submission_show = false;
      },
      hasEvaluation(submission) {
        return (
          submission.assessments.length ||
          (submission.evaluation &&
            ((submission.evaluation.auto_save === false &&
              submission.evaluation.comment) ||
              (submission.evaluation.auto_save &&
                !submission.evaluation.comment)))
        );
      },
    },
    mounted() {
      this.isMountedFromNotification();
      EventBus.$on('myContext', (comment) => {
        if (this.submission.id === comment.submission_id) {
          this.handleTabButtons('comments', true);
          this.scrollToSubmission(true);
          /* Need Refactoring */
          setTimeout(() => {
            const element = document.getElementById(
              `comment-reply-${comment.comment_id}`
            );
            if (element) {
              element.click();
            }
          }, 1000);
        }
      });

      if (this.isPlagPanel) {
        this.getCurrentRT.submissions.forEach((sub) => {
          if (sub.id === this.submission.id) {
            if (this.isAnonForPlagPanel) {
              this.imageUrl = encodeImageUrl(sub.anonymous_identity.avatar_url);
              this.plagStudentName = sub.anonymous_identity.name;
            } else {
              this.imageUrl = encodeImageUrl(sub.user.avatar_url);
              this.plagStudentName = sub.user.name;
            }
          }
        });
      }
      this.isMountedFromStudentReports();
      this.model_submission_show = false;
    },
    beforeDestroy() {
      EventBus.$off('myContext');
    },
  });
</script>
<style scoped lang="stylus">
  .next-submission-btn
    position: absolute
    margin-top: 15%
    left: 4px
    display:inline-grid
    font-weight:bold
    cursor:pointer
    z-index: 99
</style>
<style lang="scss">
  .submission-response h2 {
    font-size: 24px;
    font-weight: 700;
    margin: 20px 0;
  }
  .submission-response h3 {
    font-size: 18px;
    font-weight: 700;
    margin: 14px 0;
  }
  .submission-response p {
    font-size: 14px;
    margin: 10px 0;
  }
  .submission-response ul {
    list-style-type: disc;
  }
  .submission-response ol {
    list-style-type: decimal;
  }
  .submission-response b {
    font-weight: 700;
  }
  .submission-response strong {
    font-weight: 700;
  }
  .submission-response table {
    border-collapse: collapse;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgba(161, 161, 170, var(--tw-border-opacity));
  }
  .submission-response td {
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgba(212, 212, 216, var(--tw-border-opacity));
  }
  .submission-response a {
    color: blue;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// submissionCard.vue?37c7a220